var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10167_22327",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 8,
    height: 8
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10167_22327)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.666748 8.00002V7.00002H7.33341V8.00002H0.666748ZM2.00008 5.47118H2.41225L5.17891 2.7096L4.96933 2.49685L4.76166 2.29235L2.00008 5.05902V5.47118ZM1.50008 5.97118V4.84618L5.23666 1.11477C5.28494 1.06649 5.33975 1.02996 5.40108 1.00518C5.46236 0.980407 5.52614 0.968018 5.59241 0.968018C5.65875 0.968018 5.72297 0.980407 5.78508 1.00518C5.84719 1.02996 5.90411 1.06821 5.95583 1.11993L6.3565 1.52568C6.40822 1.57396 6.44561 1.62927 6.46866 1.6916C6.49172 1.75388 6.50325 1.81827 6.50325 1.88477C6.50325 1.9471 6.49155 2.00907 6.46816 2.07068C6.44478 2.13235 6.40755 2.18871 6.3565 2.23977L2.62508 5.97118H1.50008ZM5.17891 2.7096L4.96933 2.49685L4.76166 2.29235L5.17891 2.7096Z",
    fill: "#15182C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.2e975f4f0ef33696b393d3069f39b29c.svg";
export { ForwardRef as ReactComponent };